// extracted by mini-css-extract-plugin
export default {"button":"Button_button__urX8I","buttonConfirm":"Button_buttonConfirm__j+nhk"};